import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { RefreshTokenViewModel } from 'src/app/interfaces/auth';
import { ResponseModel } from 'src/app/interfaces/merchant';
import { StoreService } from './store.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl: string;
  userController: string;
  otpController: string;


  constructor(
    private http: HttpClient, private store: StoreService
  ) {
    this.baseUrl = `${environment.apiEndPoint}/Auth`;
    this.userController = '/User';
    this.otpController = '/OtpUser';
  }

  login(data: any): Observable<object> {
    return this.http.post(`${this.baseUrl}${this.userController}/Login`, data);
  }
  sendOtp(data: any): Observable<object> {
    return this.http.post(`${this.baseUrl}${this.userController}/OtpLogin`, data);
  }
  refreshToken(data: RefreshTokenViewModel): Observable<ResponseModel<RefreshTokenViewModel>> {
    return this.http.post(`${this.baseUrl}${this.userController}/RefreshToken`, data)
      .pipe(map(res => {
        return res;
      }));
  }

  addPrimaryOrSecondaryPhone(data: any){
    return this.http.post(`${this.baseUrl}${this.userController}/UpdatePrimaryOrAddSecondaryNumber`, data)
  }

  getPhoneNumbers(){
    return this.http.get(`${this.baseUrl}${this.userController}/GetCustomerPhoneNumbers`)
  }

  deletePhoneNumber(id: any){
    return this.http.post(`${this.baseUrl}${this.userController}/DeleteSecondaryPhoneNumber/${id}`,{})
  }

  isMarketplace(){
    return location.hostname === environment.marketPlaceHostName;
  }

  getShopSettingsData(){
    return this.http.get(`${environment.apiEndPoint}/Tenant/ShopSetting/GetAllSocialLinks`)
  }
}
